import { gql } from '@apollo/client';

export const GET_PROGRAM_BY_ID = gql`
  query GetProgramById($id: Uuid!) {
    programs(where: { id: { _eq: $id } }) {
      id
      name
      description
      about
      image
      price
      duration
      durationMetric
      inviteOnly
      subscriptionOnly
      published
      achievements
      organisationId
      programTags {
        tag
      }
      programCourses {
        course {
          id
          openedxCourseId
          details: _CourseOverviewsCourseoverview {
            displayName
            courseImageUrl
            effort
            shortDescription
            start
          }
        }
      }
    }
  }
`;

export const IS_ENROLLED_IN_PROGRAM = gql`
  query IsEnrolledInProgram($userId: Int4!, $programId: Uuid!) {
    programEnrollments(
      where: {
        userId: { _eq: $userId }
        programId: { _eq: $programId }
      }
      limit: 1
    ) {
      id
    }
  }
`;
